import { Component, inject, ViewChild } from '@angular/core';

import Player from '@vimeo/player';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    standalone: true,
    imports: [FontAwesomeModule, DynamicDialogModule],
    selector: 'qwyk-vimeo-player-modal',
    templateUrl: './vimeo-player-modal.component.html',
    styleUrls: ['./vimeo-player-modal.component.scss'],
})
export class VimeoPlayerModalComponent {

    public modal = inject(DynamicDialogRef);

    // @HostBinding('class') _class = 'h-100 d-flex flex-column';
    @ViewChild('player_container', { static: true }) playerContainer: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        nativeElement: any;
    };
    public title: string | null = null;
    private player: Player;

    public playVideo(id: number): void {
        this.player = new Player(this.playerContainer.nativeElement, {
            id,
            autoplay: true,
            responsive: true,
        });

        this.player
            .getVideoTitle()
            .then((title: string | null) => (this.title = title));
    }
}
